<div class="dashboard-status" *ngIf="loading">Loading…</div>
<div class="dashboard-status error" *ngIf="loadError">
	Unable to load this employer. <button type="button" (click)="reload()">Retry</button>
</div>

<div class="comm-dashboard-detail" *ngIf="employerDetail && !loadError">

	<!-- ── Employer Summary (lifecycle + all-time) ─────────────────────── -->
	<div class="employer-summary">

		<!-- Left: Lifecycle -->
		<div class="summary-block lifecycle">
			<div class="summary-block-header">
				<span class="material-symbols-outlined">flag</span>
				Employer Profile
				<span class="stage-badge" [ngClass]="getStage()">
					<span class="stage-dot"></span>{{ getStageLabel(getStage()) }}
				</span>
			</div>

			<div class="lifecycle-grid">
				<div class="lc-item">
					<span class="lc-label">Drip Start</span>
					<span class="lc-value" [class.lc-missing]="!employerDetail.lifecycle.dripStartDate">
						<ng-container *ngIf="employerDetail.lifecycle.dripStartDate; else lcDash">{{ employerDetail.lifecycle.dripStartDate | date:'MM/dd/yyyy' }}</ng-container>
					</span>
				</div>
				<div class="lc-item">
					<span class="lc-label">Census Loaded</span>
					<span class="lc-value" [class.lc-missing]="employerDetail.lifecycle.censusLoaded === 0">
						<ng-container *ngIf="employerDetail.lifecycle.censusLoaded > 0; else lcDash">{{ employerDetail.lifecycle.censusLoaded | number }}</ng-container>
					</span>
				</div>
				<div class="lc-item">
					<span class="lc-label">Comm Preference</span>
					<span class="lc-value lc-comm">
						<span class="material-symbols-outlined">{{ getCommPrefIcon(employerDetail.lifecycle.commPreference) }}</span>
						{{ getCommPrefLabel(employerDetail.lifecycle.commPreference) }}
					</span>
				</div>
				<div class="lc-item">
					<span class="lc-label">Campaigns</span>
					<span class="lc-value">{{ employerDetail.lifecycle.campaignsSent }}/{{ employerDetail.lifecycle.campaignsTotal }}</span>
				</div>
				<div class="lc-item">
					<span class="lc-label">Last Drip</span>
					<span class="lc-value">
						<ng-container *ngIf="employerDetail.lifecycle.lastCampaign; else lcDash">{{ employerDetail.lifecycle.lastCampaign | date:'MM/dd/yyyy' }}</ng-container>
					</span>
				</div>
				<div class="lc-item">
					<span class="lc-label">Next Drip</span>
					<span class="lc-value">
						<ng-container *ngIf="employerDetail.lifecycle.nextCampaign; else lcDash">{{ employerDetail.lifecycle.nextCampaign | date:'MM/dd/yyyy' }}</ng-container>
					</span>
				</div>
			</div>
		</div>

		<!-- Right: All-Time Performance -->
		<div class="summary-block all-time">
			<div class="summary-block-header">
				<span class="material-symbols-outlined">history</span>
				All-Time Performance
			</div>

			<div class="all-time-section">
				<div class="all-time-section-label">
					<span class="material-symbols-outlined">email</span> Email
				</div>
				<div class="stat-strip compact">
					<div class="stat-item">
						<span class="stat-label">REQUESTS</span>
						<span class="stat-value">{{ employerDetail.allTimeEmail.requests | number }}</span>
					</div>
					<div class="stat-item delivered">
						<span class="stat-label">DELIVERED</span>
						<span class="stat-value" [ngClass]="{ 'warn': employerDetail.allTimeEmail.deliveredPct < 95 }">
							{{ employerDetail.allTimeEmail.deliveredPct | number:'1.1-1' }}%
						</span>
					</div>
					<div class="stat-item opened">
						<span class="stat-label">OPENED</span>
						<span class="stat-value">{{ employerDetail.allTimeEmail.openedPct | number:'1.1-1' }}%</span>
					</div>
					<div class="stat-item clicked">
						<span class="stat-label">CLICKED</span>
						<span class="stat-value">{{ employerDetail.allTimeEmail.clickedPct | number:'1.1-1' }}%</span>
					</div>
					<div class="stat-item bounced">
						<span class="stat-label">BOUNCES</span>
						<span class="stat-value" [ngClass]="{ 'warn': employerDetail.allTimeEmail.bouncesPct > 3 }">
							{{ employerDetail.allTimeEmail.bouncesPct | number:'1.2-2' }}%
						</span>
					</div>
					<div class="stat-item spam">
						<span class="stat-label">SPAM</span>
						<span class="stat-value" [ngClass]="{ 'warn': employerDetail.allTimeEmail.spamPct > 0.1 }">
							{{ employerDetail.allTimeEmail.spamPct | number:'1.2-2' }}%
						</span>
					</div>
					<div class="stat-item unsubscribed">
						<span class="stat-label">UNSUBS</span>
						<span class="stat-value">{{ employerDetail.allTimeEmail.unsubscribedPct | number:'1.2-2' }}%</span>
					</div>
				</div>
			</div>

			<div class="all-time-section">
				<div class="all-time-section-label">
					<span class="material-symbols-outlined">sms</span> SMS
				</div>
				<div class="stat-strip compact">
					<div class="stat-item">
						<span class="stat-label">SENT</span>
						<span class="stat-value">{{ employerDetail.allTimeSms.sent | number }}</span>
					</div>
					<div class="stat-item delivered">
						<span class="stat-label">DELIVERED</span>
						<span class="stat-value">{{ employerDetail.allTimeSms.deliveredPct | number:'1.1-1' }}%</span>
					</div>
					<div class="stat-item bounced">
						<span class="stat-label">UNDELIVERED</span>
						<span class="stat-value" [ngClass]="{ 'warn': employerDetail.allTimeSms.undeliveredPct > 5 }">
							{{ employerDetail.allTimeSms.undeliveredPct | number:'1.1-1' }}%
						</span>
					</div>
					<div class="stat-item spam">
						<span class="stat-label">FAILED</span>
						<span class="stat-value" [ngClass]="{ 'warn': employerDetail.allTimeSms.failedPct > 5 }">
							{{ employerDetail.allTimeSms.failedPct | number:'1.1-1' }}%
						</span>
					</div>
				</div>
			</div>
		</div>

	</div>

	<ng-template #lcDash><span class="text-muted">—</span></ng-template>

	<!-- ── Period Activity Section Header ─────────────────────────────── -->
	<div class="period-header">
		<div class="period-header-title">
			<span class="material-symbols-outlined">trending_up</span>
			Recent Activity
		</div>
		<div class="period-toggle">
			<button [class.active]="period === 'week'" (click)="setPeriod('week')">Wk</button>
			<button [class.active]="period === 'month'" (click)="setPeriod('month')">Mo</button>
		</div>
	</div>

	<!-- ── System Alerts ────────────────────────────────────────────── -->
	<div class="alerts-section" *ngIf="employerDetail.systemAlerts.length > 0">
		<div class="alerts-header">
			<span class="material-symbols-outlined">notifications_active</span>
			System Alerts
		</div>
		<div *ngFor="let alert of employerDetail.systemAlerts" class="alert-item" [ngClass]="alert.type">
			<span class="material-symbols-outlined alert-icon">
				{{ alert.type === 'error' ? 'error' : alert.type === 'warning' ? 'warning' : 'info' }}
			</span>
			<div class="alert-body">
				<span class="alert-category">{{ alert.category }}</span>
				<span class="alert-message">{{ alert.message }}</span>
			</div>
		</div>
	</div>

	<!-- ── Charts Row ─────────────────────────────────────────────────── -->
	<div class="chart-panels" *ngIf="emailChart && smsChart">

		<!-- Email Panel -->
		<div class="chart-panel">
			<div class="panel-header">
				<span class="material-symbols-outlined">email</span>
				Email Activity — {{ period === 'week' ? 'This Week' : 'Last 4 Weeks' }}
			</div>

			<div class="stat-strip">
				<div class="stat-item">
					<span class="stat-label">REQUESTS</span>
					<span class="stat-value">{{ employerDetail.emailStats.requests | number }}</span>
				</div>
				<div class="stat-item delivered">
					<span class="stat-label">DELIVERED</span>
					<span class="stat-value" [ngClass]="{ 'warn': employerDetail.emailStats.deliveredPct < 95 }">
						{{ employerDetail.emailStats.deliveredPct | number:'1.1-1' }}%
					</span>
				</div>
				<div class="stat-item opened">
					<span class="stat-label">OPENED</span>
					<span class="stat-value">{{ employerDetail.emailStats.openedPct | number:'1.1-1' }}%</span>
				</div>
				<div class="stat-item clicked">
					<span class="stat-label">CLICKED</span>
					<span class="stat-value">{{ employerDetail.emailStats.clickedPct | number:'1.1-1' }}%</span>
				</div>
				<div class="stat-item bounced">
					<span class="stat-label">BOUNCES</span>
					<span class="stat-value" [ngClass]="{ 'warn': employerDetail.emailStats.bouncesPct > 3 }">
						{{ employerDetail.emailStats.bouncesPct | number:'1.2-2' }}%
					</span>
				</div>
				<div class="stat-item spam">
					<span class="stat-label">SPAM</span>
					<span class="stat-value" [ngClass]="{ 'warn': employerDetail.emailStats.spamPct > 0.1 }">
						{{ employerDetail.emailStats.spamPct | number:'1.2-2' }}%
					</span>
				</div>
				<div class="stat-item unsubscribed">
					<span class="stat-label">UNSUBS</span>
					<span class="stat-value">{{ employerDetail.emailStats.unsubscribedPct | number:'1.2-2' }}%</span>
				</div>
			</div>

			<div class="chart-container">
				<svg viewBox="0 0 480 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
					<g *ngFor="let g of emailChart.gridLines">
						<line x1="55" [attr.x2]="470" [attr.y1]="g.y" [attr.y2]="g.y" class="grid-line" />
						<text x="48" [attr.y]="g.y + 4" class="y-label">{{ g.label }}</text>
					</g>
					<text *ngFor="let xl of emailChart.xLabels" [attr.x]="xl.x" y="185" class="x-label">{{ xl.label }}</text>
					<polygon *ngFor="let s of emailChart.series"
						[attr.points]="s.areaPoints" [attr.fill]="s.color" fill-opacity="0.07" />
					<polyline *ngFor="let s of emailChart.series"
						[attr.points]="s.points" [attr.stroke]="s.color"
						fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
					<ng-container *ngFor="let s of emailChart.series">
						<circle *ngFor="let d of s.dots"
							[attr.cx]="d.x" [attr.cy]="d.y" r="3.5"
							[attr.fill]="s.color" stroke="white" stroke-width="1.5" />
					</ng-container>
				</svg>
			</div>

			<div class="legend">
				<span *ngFor="let s of emailChart.series" class="legend-item">
					<span class="legend-dot" [style.background]="s.color"></span>{{ s.label }}
				</span>
			</div>
		</div>

		<!-- SMS Panel -->
		<div class="chart-panel">
			<div class="panel-header">
				<span class="material-symbols-outlined">sms</span>
				SMS Activity — {{ period === 'week' ? 'This Week' : 'Last 4 Weeks' }}
			</div>

			<div class="stat-strip">
				<div class="stat-item">
					<span class="stat-label">SENT</span>
					<span class="stat-value">{{ employerDetail.smsStats.sent | number }}</span>
				</div>
				<div class="stat-item delivered">
					<span class="stat-label">DELIVERED</span>
					<span class="stat-value">{{ employerDetail.smsStats.deliveredPct | number:'1.1-1' }}%</span>
				</div>
				<div class="stat-item bounced">
					<span class="stat-label">UNDELIVERED</span>
					<span class="stat-value" [ngClass]="{ 'warn': employerDetail.smsStats.undeliveredPct > 5 }">
						{{ employerDetail.smsStats.undeliveredPct | number:'1.1-1' }}%
					</span>
				</div>
				<div class="stat-item spam">
					<span class="stat-label">FAILED</span>
					<span class="stat-value" [ngClass]="{ 'warn': employerDetail.smsStats.failedPct > 5 }">
						{{ employerDetail.smsStats.failedPct | number:'1.1-1' }}%
					</span>
				</div>
			</div>

			<div class="chart-container">
				<svg viewBox="0 0 480 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
					<g *ngFor="let g of smsChart.gridLines">
						<line x1="55" [attr.x2]="470" [attr.y1]="g.y" [attr.y2]="g.y" class="grid-line" />
						<text x="48" [attr.y]="g.y + 4" class="y-label">{{ g.label }}</text>
					</g>
					<text *ngFor="let xl of smsChart.xLabels" [attr.x]="xl.x" y="185" class="x-label">{{ xl.label }}</text>
					<polygon *ngFor="let s of smsChart.series"
						[attr.points]="s.areaPoints" [attr.fill]="s.color" fill-opacity="0.07" />
					<polyline *ngFor="let s of smsChart.series"
						[attr.points]="s.points" [attr.stroke]="s.color"
						fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
					<ng-container *ngFor="let s of smsChart.series">
						<circle *ngFor="let d of s.dots"
							[attr.cx]="d.x" [attr.cy]="d.y" r="3.5"
							[attr.fill]="s.color" stroke="white" stroke-width="1.5" />
					</ng-container>
				</svg>
			</div>

			<div class="legend">
				<span *ngFor="let s of smsChart.series" class="legend-item">
					<span class="legend-dot" [style.background]="s.color"></span>{{ s.label }}
				</span>
			</div>
		</div>

	</div>

	<!-- ── Campaign Performance Table ───────────────────────────────── -->
	<div class="section-header">
		<span class="material-symbols-outlined">campaign</span>
		Campaign Performance
	</div>

	<div class="campaign-grid">
		<!-- grouped channel band -->
		<div class="group-spacer span-3"></div>
		<div class="group-band email span-5">Email</div>
		<div class="group-band sms span-2">SMS</div>
		<div class="group-spacer span-1"></div>

		<!-- column headers -->
		<div class="header sortable" (click)="sortCampaigns('name')">
			Campaign <span class="sort-icon" [ngClass]="getSortIcon('name')"></span>
		</div>
		<div class="header sortable" (click)="sortCampaigns('type')">
			Type <span class="sort-icon" [ngClass]="getSortIcon('type')"></span>
		</div>
		<div class="header sortable" (click)="sortCampaigns('date')">
			Send Date <span class="sort-icon" [ngClass]="getSortIcon('date')"></span>
		</div>
		<div class="header sortable" (click)="sortCampaigns('emailSent')">
			Sent <span class="sort-icon" [ngClass]="getSortIcon('emailSent')"></span>
		</div>
		<div class="header sortable" (click)="sortCampaigns('emailDeliveredPct')">
			Del. <span class="sort-icon" [ngClass]="getSortIcon('emailDeliveredPct')"></span>
		</div>
		<div class="header sortable" (click)="sortCampaigns('openedPct')">
			Opened <span class="sort-icon" [ngClass]="getSortIcon('openedPct')"></span>
		</div>
		<div class="header sortable" (click)="sortCampaigns('clickedPct')">
			Clicked <span class="sort-icon" [ngClass]="getSortIcon('clickedPct')"></span>
		</div>
		<div class="header sortable" (click)="sortCampaigns('bouncedPct')">
			Bounced <span class="sort-icon" [ngClass]="getSortIcon('bouncedPct')"></span>
		</div>
		<div class="header sortable" (click)="sortCampaigns('smsSent')">
			Sent <span class="sort-icon" [ngClass]="getSortIcon('smsSent')"></span>
		</div>
		<div class="header sortable" (click)="sortCampaigns('smsDeliveredPct')">
			Del. <span class="sort-icon" [ngClass]="getSortIcon('smsDeliveredPct')"></span>
		</div>
		<div class="header">Issues</div>

		<ng-container *ngFor="let c of campaigns">
			<div class="cell name-cell">{{ c.name }}</div>
			<div class="cell center">
				<span class="type-badge" [ngClass]="c.type.toLowerCase()">{{ c.type }}</span>
			</div>
			<div class="cell center send-date-cell" [class.is-scheduled]="c.isScheduled" [ngClass]="c.scheduleStatus">
				<span class="date-value">{{ c.date | date:'MM/dd/yyyy' }}</span>
				<span class="scheduled-tag" *ngIf="c.isScheduled">
					<span class="material-symbols-outlined">{{ scheduleIcon(c.scheduleStatus) }}</span>{{ c.scheduleStatus }}
				</span>
			</div>

			<!-- Email -->
			<div class="cell center"><ng-container *ngIf="c.emailSent > 0; else dash">{{ c.emailSent | number }}</ng-container></div>
			<div class="cell center" [ngClass]="{ 'rate-warn': c.emailDeliveredPct != null && c.emailDeliveredPct < 95 }">
				<ng-container *ngIf="c.emailSent > 0; else dash">{{ c.emailDeliveredPct | number:'1.1-1' }}%</ng-container>
			</div>
			<div class="cell center"><ng-container *ngIf="c.emailSent > 0; else dash">{{ c.openedPct | number:'1.1-1' }}%</ng-container></div>
			<div class="cell center"><ng-container *ngIf="c.emailSent > 0; else dash">{{ c.clickedPct | number:'1.1-1' }}%</ng-container></div>
			<div class="cell center" [ngClass]="{ 'rate-warn': c.bouncedPct != null && c.bouncedPct > 3 }">
				<ng-container *ngIf="c.emailSent > 0; else dash">{{ c.bouncedPct | number:'1.2-2' }}%</ng-container>
			</div>

			<!-- SMS -->
			<div class="cell center"><ng-container *ngIf="c.smsSent > 0; else dash">{{ c.smsSent | number }}</ng-container></div>
			<div class="cell center" [ngClass]="{ 'rate-warn': c.smsDeliveredPct != null && c.smsDeliveredPct < 95 }">
				<ng-container *ngIf="c.smsSent > 0; else dash">{{ c.smsDeliveredPct | number:'1.1-1' }}%</ng-container>
			</div>

			<!-- Issues -->
			<div class="cell">
				<ng-container *ngIf="c.flags.length > 0">
					<div class="flag-list">
						<span *ngFor="let f of c.flags" class="flag-item">
							<span class="material-symbols-outlined">warning</span>{{ f }}
						</span>
					</div>
				</ng-container>
				<!-- No flags: "All Good" only for sent rows; unsent rows (scheduled/overdue/paused) show a muted dash. -->
				<ng-container *ngIf="c.flags.length === 0 && !c.isScheduled">
					<span class="status-badge ok">
						<span class="material-symbols-outlined">check_circle</span> All Good
					</span>
				</ng-container>
				<ng-container *ngIf="c.flags.length === 0 && c.isScheduled">
					<span class="text-muted">—</span>
				</ng-container>
			</div>
		</ng-container>
	</div>

	<ng-template #dash><span class="text-muted">—</span></ng-template>

</div>
